module.exports = __webpack_public_path__ + "static/cloud-ab7010df03cc227ee174158161565a22.gif";